var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333132",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.224 14.96A.938.938 0 0 1 3.9 16.286L.273 12.659a.94.94 0 0 1 0-1.325L3.9 7.707a.937.937 0 1 1 1.325 1.326L3.2 11.059h11.795a.937.937 0 0 1 0 1.875H3.199l2.025 2.026z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.323.364a.937.937 0 0 0-.741-.363H7.97a.937.937 0 0 0 0 1.875h11.142c2.047 2.838 3.013 6.537 3.013 10.125 0 3.587-.965 7.286-3.013 10.125H7.97a.937.937 0 0 0 0 1.875h11.612c.29 0 .563-.134.74-.363C22.814 20.423 24 16.167 24 12S22.813 3.579 20.323.364z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.cee943d4f64fdb433b43f87b664ae847.svg";
export { ForwardRef as ReactComponent };